module.exports = __webpack_public_path__ + "img/01.0f84cfe8.jpg";